var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAmmortamenti(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "618px",
    height: "376px",
    viewBox: "0 0 618 376",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ammortamento---Sospensione-cespiti",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.6---Ammortamento/Sospensione-|-Ammortemento-generato-",
    transform: "translate(-416.000000, -190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(416.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(117.247632, 96.395415)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.6339369,73.7378066 L114.507774,88.1073854 C123.468658,88.1231536 131.202127,89.0579211 137.708181,90.911688 C139.355972,91.7636431 141.611537,93.7787767 136.005663,94.8281491 C130.399789,95.8775214 124.550446,97.2334206 124.294556,99.3099684 C124.038667,101.386516 127.962879,102.736353 127.108187,105.674662 C126.538392,107.633534 120.580911,104.700866 109.235743,96.8766595 L75.3342425,92.3998673 L77.6339369,73.7378066 Z",
    id: "Arm",
    fill: "#B28B67",
    transform: "translate(107.457593, 90.000404) rotate(15.000000) translate(-107.457593, -90.000404) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7373038,13.0548089 C46.8991642,39.8448377 77.5881775,57.3265125 119.443135,72.8326472 L110.148425,91.418506 C66.9637313,87.3468071 43.8764169,84.0948982 25.7772375,57.2635478 C21.2347104,50.5294228 13.1124025,27.3585629 8.24654263,15.3259001 L21.7373038,13.0548089 Z",
    id: "Coat-Back",
    fill: "#2026A2",
    transform: "translate(63.844839, 52.236657) rotate(15.000000) translate(-63.844839, -52.236657) "
  })), /*#__PURE__*/React.createElement("g", {
    id: "Scene/Wireframe",
    transform: "translate(157.141892, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M453.149784,99.7088709 C452.779279,99.4394384 451.900267,99.3439017 451.491334,99.2631896 C449.791555,98.928105 448.040539,98.7822115 446.307649,98.7822115 C440.96421,98.7902121 435.534006,99.314723 430.279266,100.222557 C426.94303,100.798837 422.909772,102.73828 419.590937,101.685023 C413.80908,99.8498229 407.965592,99.9399474 402.480042,102.559913 C397.464812,104.955627 393.657531,109.505623 391.43571,114.422 C391.100491,115.164175 389.740523,117.895679 389.355517,119.736997 C389.190929,120.113496 389.032866,120.492584 388.890271,120.877319 C388.485689,121.969638 388.122918,123.081253 387.785766,124.194986 C387.641721,124.670081 387.279433,125.719103 387.709635,125.921942 C387.022279,127.19051 386.412988,128.497904 385.905447,129.847655 C384.42947,133.773133 382.815732,138.07911 382.297073,142.239665 C382.104933,143.780254 382.097682,145.329785 382.276047,146.873432 C382.364262,147.636315 382.327767,149.17055 382.844976,149.750595 C383.942714,150.981513 384.506326,149.258321 384.382583,148.437553 C383.43759,142.182014 385.262321,136.30768 387.424928,130.427464 C388.823324,126.625055 391.121035,123.146435 393.694992,119.996075 C395.778085,117.445997 398.012715,115.437843 400.868237,113.747125 C404.360118,111.679672 408.093444,110.00825 411.792451,108.33165 C414.225263,107.228507 416.660976,106.155013 419.161703,105.204587 C419.717823,104.993041 420.592727,104.450882 421.209268,104.448764 C422.513165,104.444058 424.360855,105.406249 425.620282,105.764159 C429.762782,106.941897 433.958212,108.449777 438.239441,109.051235 C440.985478,109.437382 443.558228,109.002761 446.126385,108.087867 C446.388856,107.994683 446.828724,107.75443 447.367685,107.411344 C449.274347,106.677876 451.07805,105.754747 452.648527,104.423115 C453.5534,103.655762 454.374408,102.664157 455.123151,101.756557 C455.347194,101.485243 455.446286,101.17416 455.449669,100.878608 C455.619333,100.789895 455.731959,100.686358 455.757336,100.565407 C455.944159,99.6721622 454.240513,99.6556903 453.149784,99.7088709",
    id: "Twisted-Leaf",
    fill: "#89C5CC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M446.725816,125.001238 C444.356684,124.483677 441.740797,124.523289 439.32755,124.565984 C426.385309,124.741983 413.676249,130.869451 405.404888,140.660164 C398.363421,148.995209 396.4272,159.358038 395.036116,169.833534 C394.898195,170.873636 394.839052,171.907096 394.761244,172.949332 C394.744519,173.173007 394.719553,173.372489 394.69289,173.560347 C394.145813,174.049444 393.858822,174.619662 394.182656,175.246095 C392.977487,177.88347 391.957989,180.587735 391.083199,183.376915 C388.508519,191.586721 385.889481,199.952601 387.502837,208.585564 C387.879756,203.834778 388.672618,198.97678 389.620852,194.304031 C389.67539,194.035763 389.734291,193.76963 389.795616,193.504445 C389.801919,193.476456 389.807736,193.448467 389.814038,193.420715 C390.14975,191.989716 390.586054,190.601649 391.116649,189.235403 C391.122224,189.22046 391.127557,189.205754 391.133374,189.191048 C391.203425,189.011254 391.277839,188.832408 391.351284,188.653563 C391.503263,188.283301 391.659363,187.913751 391.824916,187.546098 C391.880909,187.420859 391.93472,187.294434 391.986349,187.16706 C392.75885,185.273766 393.085109,183.140431 393.777136,181.181435 C393.942689,180.735982 394.115756,180.292189 394.297065,179.850769 C394.30773,179.824914 394.318638,179.79906 394.329546,179.773206 C394.819661,178.585331 395.361163,177.411926 395.933691,176.250855 C396.244921,176.01698 396.411202,175.4368 396.679529,174.909515 C396.735037,174.805623 397.168917,174.112775 397.298112,173.713576 C397.635278,173.061288 397.971232,172.408764 398.310822,171.757663 C398.300642,171.761458 398.290462,171.765253 398.280281,171.769048 C398.620114,171.143801 398.960916,170.521163 399.299052,169.901135 C399.373466,169.764984 399.448607,169.628597 399.523506,169.491973 C399.644944,169.274464 399.766382,169.057193 399.887578,168.840397 C401.021242,166.811665 402.22326,164.823493 403.471575,162.85999 C403.917091,162.159315 404.981431,161.154555 405.185524,160.367778 C405.193038,160.338366 405.194735,160.311326 405.199341,160.2831 C407.908063,156.478723 411.026427,152.969655 414.76604,150.189251 C414.31398,150.677873 413.353141,152.336106 413.099115,152.664384 C412.321766,153.669618 411.47776,154.605354 410.630602,155.552475 C409.113475,157.249134 407.632222,158.999636 406.316037,160.850708 C403.909092,164.23596 401.832526,167.798635 399.869641,171.432942 C399.850977,171.45429 399.830616,171.474451 399.812921,171.496273 C398.826389,172.712374 398.205382,174.550401 397.495176,175.941552 C400.305703,174.639824 403.413402,173.79185 406.297858,172.635997 C409.174315,171.483702 411.97248,170.200475 414.673931,168.693573 C418.264474,166.690932 421.989058,164.429749 425.381567,161.870885 C429.269281,159.45932 432.53623,156.140008 435.41996,152.656794 C438.831859,148.535525 441.958707,144.378202 443.892505,139.374091 C444.842436,136.915087 445.589729,134.351005 446.03282,131.757036 C446.052211,131.643894 446.076935,131.521264 446.10384,131.39389 C446.557112,130.498003 446.96239,129.581955 447.302465,128.644796 C447.842513,127.15853 449.117976,125.523542 446.725816,125.001238",
    id: "Fill-10",
    fill: "#69A1AC"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Background-Shape-2",
    opacity: 0.6,
    transform: "translate(0.000000, 212.820889)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M460.515234,101.661876 C467.230961,147.100411 304.363154,176.738413 164.179058,156.054766 C23.9949609,135.371119 -40.3148559,54.599145 26.5786579,11.560662 C93.4721717,-31.477821 453.799507,56.2233399 460.515234,101.661876 Z",
    id: "Background-Shape"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mobile3",
    transform: "translate(43.008290, 19.819242)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#F2F2F2",
    x: 0,
    y: 0,
    width: 110.436123,
    height: 209.759178,
    rx: 5.55653451
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Touch",
    fill: "#FFFFFF",
    cx: 54.8707783,
    cy: 186.143906,
    r: 10.4185022
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(44.452276, 11.113069)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Lens",
    cx: 1.38913363,
    cy: 1.38913363,
    r: 1.38913363
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Sensor",
    x: 6.25110132,
    y: 0,
    width: 14.5859031,
    height: 2.77826725,
    rx: 1.38913363
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rows",
    transform: "translate(9.723935, 19.447871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90.9882526,
    height: 37.5066079,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    transform: "translate(27.088106, 11.251982)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 0,
    width: 50.7033774,
    height: 5.62599119,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 9.37665198,
    width: 34.0337739,
    height: 5.62599119,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#C5CFD6",
    cx: 14.5859031,
    cy: 18.753304,
    r: 8.33480176
  })), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 43.063142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90.9882526,
    height: 29.1718062,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    transform: "translate(27.088106, 8.751542)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 0,
    width: 50.7033774,
    height: 4.37577093,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 7.29295154,
    width: 34.0337739,
    height: 4.37577093,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#C5CFD6",
    cx: 14.5859031,
    cy: 14.5859031,
    r: 8.33480176
  })), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 77.791483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90.9882526,
    height: 29.1718062,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    transform: "translate(27.088106, 8.751542)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 0,
    width: 50.7033774,
    height: 4.37577093,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 7.29295154,
    width: 34.0337739,
    height: 4.37577093,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#AFB9C5",
    cx: 14.5859031,
    cy: 14.5859031,
    r: 8.33480176
  })), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 112.519824)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90.9882526,
    height: 29.1718062,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    transform: "translate(27.088106, 8.751542)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 0,
    width: 50.7033774,
    height: 4.37577093,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 7.29295154,
    width: 34.0337739,
    height: 4.37577093,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#C5CFD6",
    cx: 14.5859031,
    cy: 14.5859031,
    r: 8.33480176
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Mobile3",
    transform: "translate(81.568416, 34.904536)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(0.000000, 151.415565)",
    fill: "#89C5CC"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.43194594,0 C7.51176588,0 6.59439124,0.0184770488 5.67536636,0.0662904645 C4.97483473,0.102920403 3.90431679,-0.0423027169 3.31154656,0.39433912 C2.69567282,0.847837212 2.73808428,1.77622787 2.83429392,2.43183895 C3.34290134,5.89887886 4.58422028,8.97320045 7.18105554,11.4295134 C11.1794491,15.2117977 15.7631868,17.1335728 21.1872324,17.9893519 C24.9973323,18.5905043 28.5146777,17.7557956 31.3194446,15.0463146 C33.3687265,18.8498313 34.9234282,23.0588706 35.7035019,27.3069711 C36.0883405,29.4031436 36.2058384,31.4740318 36.1381781,33.6084551 C36.0946115,34.9755946 36.019195,36.3394926 35.8726527,37.7001489 C35.809118,38.2914145 35.5076171,39.1864168 35.7391473,39.7451044 C36.0107787,40.4012017 36.9268331,40.4647368 37.3380757,39.9052388 C37.6803378,39.4395848 37.6174632,38.5251329 37.6877639,37.9740631 C37.8042717,37.0586387 37.9121981,36.1425661 37.9894299,35.2229277 C38.114849,33.7343908 38.2075931,32.2416397 38.2011747,30.74743 C38.1851497,27.3902799 37.438741,24.0200013 36.4177306,20.8331967 C34.4590475,14.7194005 31.2809938,9.28585156 26.3383265,5.02267776 C23.2992239,2.40120594 19.8209895,1.33958604 15.8747438,0.769714953 C13.4178498,0.414923201 10.9208548,0 8.43194594,0",
    id: "Fill-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6229215,24.3098385 C12.6913815,24.3098385 6.00247804,32.3141393 2.83986247,40.6332666 C1.64768083,43.7690519 1.36825817,47.2123972 0.908788435,50.5050429 C0.761270188,51.5616782 0.815918623,53.1718268 0.38702599,54.1131468 C0.231375535,54.4545116 -0.125465738,54.5772513 0.0451479794,55.0423035 C0.148427017,55.3239571 0.351081632,55.4964561 0.655388844,55.5523761 C1.28010504,55.6673754 2.16342544,54.9870153 2.69901263,54.718473 C7.14147505,52.4905189 10.060287,49.045594 12.4413974,44.8307422 C13.9173931,42.2182986 15.4150205,39.5063364 16.2918351,36.6383037 C16.8274223,34.8863015 17.1392112,33.0410994 17.3223485,31.2235413 C17.3943998,30.5077968 17.4641742,29.774992 17.4599454,29.0548245 C17.4557167,28.3403438 17.123272,27.9626468 16.8843478,27.3407343 C20.1982224,26.0863254 23.9387127,25.7444867 27.2955253,27.0443898 C30.4002396,28.2466699 32.9792879,30.5700355 34.4234054,33.4889333 C34.7986254,34.2476445 35.0879694,35.0480588 35.2987562,35.8644277 C35.4366785,36.399143 35.4433469,37.0929301 35.6990235,37.5763064 C36.319023,38.748257 37.6234291,37.9647451 37.4981931,36.8738311 C37.1489961,33.830614 35.4080531,30.7753914 33.1829184,28.6595933 C30.3764935,25.9912298 26.5724094,24.3098385 22.6229215,24.3098385",
    id: "Fill-18"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#DDE3E9",
    x: 33.339207,
    y: 0,
    width: 110.436123,
    height: 209.759178,
    rx: 5.55653451
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Touch",
    fill: "#FFFFFF",
    cx: 88.2099853,
    cy: 186.143906,
    r: 10.4185022
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camera",
    transform: "translate(77.791483, 11.113069)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Lens",
    cx: 1.38913363,
    cy: 1.38913363,
    r: 1.38913363
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Sensor",
    x: 6.25110132,
    y: 0,
    width: 14.5859031,
    height: 2.77826725,
    rx: 1.38913363
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rows",
    transform: "translate(43.063142, 19.447871)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90.9882526,
    height: 37.5066079,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(6.251101, 11.251982)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 50.7033774,
    height: 5.62599119,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 9.37665198,
    width: 34.0337739,
    height: 5.62599119,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(76.402349, 13.891336)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#DDE3E9",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 4.86196769
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 2.08370044
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 43.063142)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90.9882526,
    height: 29.1718062,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    transform: "translate(27.088106, 8.751542)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 0,
    width: 50.7033774,
    height: 4.37577093,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 7.29295154,
    width: 34.0337739,
    height: 4.37577093,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#C5CFD6",
    cx: 14.5859031,
    cy: 14.5859031,
    r: 8.33480176
  })), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 77.791483)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90.9882526,
    height: 29.1718062,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(6.251101, 8.751542)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    fill: "#DDE3E9",
    x: 0,
    y: 0,
    width: 50.7033774,
    height: 4.37577093,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    fill: "#AFB9C5",
    x: 0,
    y: 7.29295154,
    width: 34.0337739,
    height: 4.37577093,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(76.402349, 9.723935)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#DDE3E9",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 4.86196769
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 2.08370044
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 112.519824)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 90.9882526,
    height: 29.1718062,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text",
    transform: "translate(27.088106, 8.751542)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 0,
    width: 50.7033774,
    height: 4.37577093,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 7.29295154,
    width: 34.0337739,
    height: 4.37577093,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    fill: "#C5CFD6",
    cx: 14.5859031,
    cy: 14.5859031,
    r: 8.33480176
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Web",
    transform: "translate(160.994518, 52.316713)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#F2F2F2",
    x: 0,
    y: 0,
    width: 232.679883,
    height: 240.320117,
    rx: 5.55653451
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 172.947137,
    y: 29.866373,
    width: 48.6196769,
    height: 56.2599119,
    rx: 5.55653451
  }), /*#__PURE__*/React.createElement("g", {
    id: "Profile-Info",
    transform: "translate(179.892805, 40.284875)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Avatar",
    cx: 17.3641703,
    cy: 11.113069,
    r: 11.113069
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 0,
    y: 25.0044053,
    width: 34.7283407,
    height: 4.16740088,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Name",
    x: 5.55653451,
    y: 31.9500734,
    width: 23.6152717,
    height: 4.16740088,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.55653451,0 L227.123348,0 C230.192137,3.24450976e-16 232.679883,2.48774524 232.679883,5.55653451 L232.679883,18.753304 L232.679883,18.753304 L0,18.753304 L0,5.55653451 C5.12360124e-16,2.48774524 2.48774524,5.63727444e-16 5.55653451,0 Z",
    id: "Header",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Buttons",
    transform: "translate(6.251101, 6.945668)",
    fill: "#F2F2F2"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "buttons",
    cx: 2.77826725,
    cy: 2.77826725,
    r: 2.77826725
  }), /*#__PURE__*/React.createElement("circle", {
    id: "buttons",
    cx: 11.113069,
    cy: 2.77826725,
    r: 2.77826725
  }), /*#__PURE__*/React.createElement("circle", {
    id: "buttons",
    cx: 19.4478708,
    cy: 2.77826725,
    r: 2.77826725
  })), /*#__PURE__*/React.createElement("g", {
    id: "Components",
    transform: "translate(172.947137, 91.682819)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Background",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 48.6196769,
    height: 134.745962,
    rx: 5.55653451
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rows",
    transform: "translate(12.502203, 12.502203)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Data",
    fill: "#DDE3E9",
    x: 0,
    y: 0,
    width: 23.6152717,
    height: 18.0587372,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data",
    fill: "#AFB9C5",
    x: 0,
    y: 23.6152717,
    width: 23.6152717,
    height: 17.3641703,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data",
    fill: "#DDE3E9",
    x: 0,
    y: 46.5359765,
    width: 23.6152717,
    height: 17.3641703,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data",
    fill: "#DDE3E9",
    x: 0,
    y: 92.3773862,
    width: 23.6152717,
    height: 17.3641703,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Data",
    fill: "#C5CFD6",
    x: 0,
    y: 69.4566814,
    width: 23.6152717,
    height: 17.3641703,
    rx: 2.77826725
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Rows",
    transform: "translate(11.113069, 30.560940)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Row"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 156.277533,
    height: 32.6446402,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(6.251101, 9.793392)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 115.992658,
    height: 4.89669604,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 8.16116006,
    width: 77.8580854,
    height: 4.89669604,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(134.714150, 11.460352)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#DDE3E9",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 4.86196769
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 2.08370044
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 38.201175)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 156.277533,
    height: 27.0881057,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(6.251101, 8.126432)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 115.992658,
    height: 4.06321586,
    rx: 2.03160793
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 6.77202643,
    width: 77.8580854,
    height: 4.06321586,
    rx: 2.03160793
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(134.714150, 8.682085)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#DDE3E9",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 4.86196769
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 2.08370044
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 70.845815)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 156.277533,
    height: 27.0881057,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(6.251101, 8.126432)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 115.992658,
    height: 4.06321586,
    rx: 2.03160793
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 6.77202643,
    width: 77.8580854,
    height: 4.06321586,
    rx: 2.03160793
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(134.714150, 8.682085)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#DDE3E9",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 4.86196769
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#AFB9C5",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 2.08370044
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 168.779736)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 156.277533,
    height: 27.0881057,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(6.251101, 8.126432)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 115.992658,
    height: 4.06321586,
    rx: 2.03160793
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 6.77202643,
    width: 77.8580854,
    height: 4.06321586,
    rx: 2.03160793
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(134.714150, 8.682085)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#DDE3E9",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 4.86196769
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 2.08370044
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 136.135095)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 156.277533,
    height: 27.0881057,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(6.251101, 8.126432)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 115.992658,
    height: 4.06321586,
    rx: 2.03160793
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 6.77202643,
    width: 77.8580854,
    height: 4.06321586,
    rx: 2.03160793
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(134.714150, 8.682085)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#DDE3E9",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 4.86196769
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 2.08370044
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Row",
    transform: "translate(0.000000, 103.490455)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 156.277533,
    height: 27.0881057,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "Text-Stuff",
    transform: "translate(6.251101, 8.126432)",
    fill: "#DDE3E9"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 0,
    width: 115.992658,
    height: 4.06321586,
    rx: 2.03160793
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Label",
    x: 0,
    y: 6.77202643,
    width: 77.8580854,
    height: 4.06321586,
    rx: 2.03160793
  })), /*#__PURE__*/React.createElement("g", {
    id: "Check",
    transform: "translate(134.714150, 8.682085)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Background",
    fill: "#DDE3E9",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 4.86196769
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Indicator",
    fill: "#F2F2F2",
    cx: 4.86196769,
    cy: 4.86196769,
    r: 2.08370044
  }))))), /*#__PURE__*/React.createElement("path", {
    d: "M451.571998,170.760139 C448.832406,168.902419 445.189277,168.415599 441.910846,168.415599 C429.105908,168.415599 417.069861,173.16647 406.672133,180.24537 C400.974694,184.124167 395.877904,189.063662 391.378172,194.20654 C388.78092,197.17524 386.465013,200.38685 384.825413,203.958696 C383.719009,206.36953 382.959607,208.88143 382.444876,211.472382 C381.817555,214.629956 381.319238,217.851572 381.093802,221.061681 C381.005064,222.325761 380.27054,229.033417 382.372295,229.146992 C382.360241,229.312351 382.35742,229.469954 382.370244,229.611297 C377.806651,236.746984 374.987041,245.109727 372.372349,253.038436 C370.097477,259.937968 368.070353,266.895788 366.754416,274.033477 C365.021974,283.43065 363.884025,292.969165 363.342877,302.501427 C363.226697,304.550022 363.146936,306.599619 363.078202,308.650966 C363.019984,310.400616 362.960996,312.150265 362.903548,313.899914 C362.839431,315.860702 362.494224,318.118185 362.80609,320.067466 C363.077433,321.765081 364.546738,321.508162 364.611625,319.818802 C364.690104,317.778712 364.677281,315.734619 364.766532,313.693028 C364.885276,310.983498 365.007612,308.273969 365.140206,305.565189 C366.063234,286.748079 369.526066,268.20765 375.916738,250.432974 C378.502962,243.239999 381.46645,236.430776 385.275258,229.776906 C388.623961,223.926563 392.652049,218.262842 396.769387,212.987877 C400.771315,207.86176 404.931997,202.854221 409.83541,198.511118 C413.814512,194.986803 418.191396,191.916536 422.690615,189.059659 C428.405237,185.431276 434.108831,181.89095 440.298944,179.105621 C443.516592,177.65792 446.795024,176.361819 450.037806,174.972656 C450.621271,174.722742 451.246797,174.480333 451.807949,174.190892 C453.679909,173.225508 453.063616,171.771553 451.571998,170.760139",
    id: "Fill-1",
    fill: "#C1DEE2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.029058,236.501532 C404.835581,236.501532 400.214197,237.176364 395.428979,239.24029 C391.298374,241.021581 387.534044,243.379713 383.879259,245.947047 C378.738382,249.557797 374.689091,253.760264 371.854684,259.32845 C370.161327,262.654911 368.919177,267.361966 370.056367,270.990189 C371.395996,275.263492 375.074186,278.827489 379.91852,278.074502 C382.914108,277.609345 385.660203,275.626408 387.936994,273.760114 C390.66065,271.527362 392.840926,268.842676 394.641174,265.86095 C397.577887,260.997111 399.303577,255.49858 401.798251,250.416094 C402.982009,248.00389 404.125954,245.57445 405.543761,243.281959 C406.245667,242.146693 406.992935,241.022289 408.057738,240.178632 C408.627418,239.727406 411.029437,238.94632 410.110855,237.932893 C423.578813,238.109747 435.510009,248.453227 438.095407,261.256371 C438.336212,262.449722 438.524417,263.652754 438.723238,264.853425 C438.848707,265.611607 438.798037,268.407506 439.475814,268.891789 C440.970592,269.960232 440.342278,266.714525 440.278096,266.247243 C440.112331,265.039488 439.935467,263.832678 439.749917,262.627993 C438.740369,256.075422 435.8232,249.983994 430.958357,245.31094 C425.395227,239.967304 417.889248,236.501532 410.029058,236.501532",
    id: "Fill-20",
    fill: "#89C5CC",
    transform: "translate(405.040541, 257.338537) scale(-1, 1) translate(-405.040541, -257.338537) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Graph",
    transform: "translate(334.792753, 0.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Value",
    fill: "#DDE3E9",
    x: 0,
    y: 22.226138,
    width: 4.16740088,
    height: 17.3641703,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value",
    fill: "#DDE3E9",
    x: 9.72393539,
    y: 11.113069,
    width: 4.16740088,
    height: 28.4772394,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value",
    fill: "#DDE3E9",
    x: 19.4478708,
    y: 5.55653451,
    width: 4.16740088,
    height: 34.0337739,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value",
    fill: "#DDE3E9",
    x: 29.1718062,
    y: 11.113069,
    width: 4.16740088,
    height: 28.4772394,
    rx: 2.08370044
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Value",
    fill: "#C5CFD6",
    x: 38.8957416,
    y: 0,
    width: 4.16740088,
    height: 39.5903084,
    rx: 2.08370044
  })), /*#__PURE__*/React.createElement("g", {
    id: "Pie-Chart",
    transform: "translate(268.263514, 25.820889) scale(-1, 1) translate(-268.263514, -25.820889) translate(254.372177, 11.929553)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7826725,14.0694149 C27.7826725,6.33264363 21.5301821,0 13.8913363,0 L13.8913363,14.0694149 L23.3846755,24.3098385 C26.0851512,21.8061861 27.7826725,18.1333653 27.7826725,14.0694149 Z",
    id: "Value",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2589149,13.8913363 L0.230596182,13.8913363 C0.230596182,17.5176696 1.70988239,20.9154905 4.04840311,23.3846755 C6.62049534,26.0851512 10.2832893,27.7826725 14.2589149,27.7826725 C17.9210074,27.7826725 21.2730742,26.3178311 23.8458678,24.0021454 L14.2589149,13.8913363 Z",
    id: "Value",
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0,13.8913363 C0,6.25249046 6.25249046,0 13.8913363,0 L13.8913363,13.8913363 L0,13.8913363 Z M20.8370044,0 L15.2804699,12.5022026 L27.7826725,6.94566814 C26.5463436,3.70481938 23.7701601,1.23632893 20.8370044,0 Z",
    id: "Value",
    fill: "#C5CFD6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    transform: "translate(419.000833, 193.375062)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.2313387,25.8232996 C24.8966738,27.2402159 23.0059856,28.1299559 20.9031307,28.1299559 C16.8625555,28.1299559 13.5870349,24.8647974 13.5870349,20.8370044 C13.5870349,16.8092115 16.8625555,13.5440529 20.9031307,13.5440529 L20.9031307,0 C9.40849911,0 0,9.37873568 0,20.8370044 C0,32.2952731 9.40849911,41.6740088 20.9031307,41.6740088 C26.9409999,41.6740088 32.3977622,39.1277269 36.1174743,35.0770132 L26.2313387,25.8232996 Z",
    id: "Value",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8370044,0 L20.8370044,13.5440529 C24.8647974,13.5440529 28.1299559,16.8092115 28.1299559,20.8370044 L41.6740088,20.8370044 C41.6740088,9.37873568 32.2952731,0 20.8370044,0 Z",
    id: "Value",
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8500202,20.8370044 C27.8500202,23.203382 26.735594,25.3068288 25.0044053,26.6649514 L33.5210457,37.5066079 C38.4785407,33.6251974 41.6740088,27.6085339 41.6740088,20.8370044 L27.8500202,20.8370044 Z",
    id: "Value",
    fill: "#C5CFD6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Chart",
    transform: "translate(292.329017, 7.645853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1779528,19.797863 C19.1512875,20.8841655 17.696912,21.5662996 16.0793313,21.5662996 C12.9711965,21.5662996 10.4515653,19.0630113 10.4515653,15.9750367 C10.4515653,12.8870621 12.9711965,10.3837739 16.0793313,10.3837739 L16.0793313,0 C7.23730701,0 0,7.19036402 0,15.9750367 C0,24.7597094 7.23730701,31.9500734 16.0793313,31.9500734 C20.7238461,31.9500734 24.9213555,29.9979239 27.7826725,26.8923768 L20.1779528,19.797863 Z",
    id: "Value",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9750367,0 L15.9750367,10.3837739 C19.0630113,10.3837739 21.5662996,12.8870621 21.5662996,15.9750367 L31.9500734,15.9750367 C31.9500734,7.19036402 24.7597094,0 15.9750367,0 Z",
    id: "Value",
    fill: "#AFB9C5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5820819,15.9750367 C21.5820819,17.7498199 20.7462623,19.327405 19.4478708,20.345997 L25.8353511,28.4772394 C29.5534723,25.5661814 31.9500734,21.0536838 31.9500734,15.9750367 L21.5820819,15.9750367 Z",
    id: "Value",
    fill: "#C5CFD6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(25.815509, 3.481005)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.344069,36.1079572 C33.3412907,36.1149029 33.3385125,36.1218486 33.3343451,36.1301834 C33.3385125,36.1232377 33.344069,36.095455 33.344069,36.1079572",
    id: "Fill-35",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3376001,36.1185128 C33.3376001,36.1199019 33.336211,36.1226802 33.336211,36.1254585 C33.336211,36.1185128 33.3487132,36.0976758 33.3376001,36.1185128",
    id: "Fill-37",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3858424,36.0009966 C33.3761185,36.0287793 33.3636163,36.0551728 33.3525032,36.0829555 C33.3580597,36.0690642 33.3636163,36.0579511 33.3691728,36.0440598 C33.2247029,36.4052345 33.3163857,36.1704709 33.3858424,36.0009966",
    id: "Fill-39",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3547481,36.084656 C33.3491915,36.0971582 33.343635,36.1110496 33.3380785,36.1235518 C33.2977936,36.2013432 33.3547481,36.084656 33.3547481,36.084656",
    id: "Fill-41",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#C5CFD6",
    points: "33.339207 36.1181689 33.339207 36.1181689 33.339207 36.1167797"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3385125,36.1188634 C33.3385125,36.1174743 33.3385125,36.1174743 33.3399016,36.1160852 C33.3385125,36.1174743 33.3385125,36.1174743 33.3385125,36.1188634",
    id: "Fill-45",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3319222,36.1288311 C33.3235874,36.1455007 33.370818,36.064931 33.3319222,36.1288311",
    id: "Fill-47",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3378179,36.1188634 L33.3405962,36.1160852 C33.339207,36.1174743 33.339207,36.1188634 33.3378179,36.1188634",
    id: "Fill-49",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Photo-Background",
    fill: "#DDE3E9",
    x: 0,
    y: 0,
    width: 65.9838473,
    height: 43.7577093,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-night_landscape",
    transform: "translate(5.556535, 12.502203)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Mountains",
    fill: "#AFB9C5",
    points: "19.4478708 0 0 31.2555066 38.8957416 31.2555066"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Mountains",
    fill: "#C5CFD6",
    points: "38.5484581 8.33480176 21.5315712 31.2555066 55.5653451 31.2555066"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Sun",
    fill: "#FFFFFF",
    cx: 51.3979442,
    cy: 14.5859031,
    r: 6.25110132
  })), /*#__PURE__*/React.createElement("g", {
    id: "Image",
    transform: "translate(391.121622, 315.767948) scale(-1, 1) translate(-391.121622, -315.767948) translate(341.807378, 283.123308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.3191057,53.4721276 C49.3163275,53.4790732 49.3135492,53.4860189 49.3093818,53.4943537 C49.3135492,53.487408 49.3191057,53.4596254 49.3191057,53.4721276",
    id: "Fill-35",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3126368,53.4826831 C49.3126368,53.4840723 49.3112477,53.4868506 49.3112477,53.4896288 C49.3112477,53.4826831 49.3237499,53.4618461 49.3126368,53.4826831",
    id: "Fill-37",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3608791,53.365167 C49.3511552,53.3929496 49.338653,53.4193432 49.3275399,53.4471259 C49.3330964,53.4332345 49.338653,53.4221214 49.3442095,53.4082301 C49.1997396,53.7694049 49.2914224,53.5346413 49.3608791,53.365167",
    id: "Fill-39",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3297848,53.4488264 C49.3242282,53.4613286 49.3186717,53.4752199 49.3131152,53.4877221 C49.2728303,53.5655136 49.3297848,53.4488264 49.3297848,53.4488264",
    id: "Fill-41",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-43",
    fill: "#C5CFD6",
    points: "49.3142438 53.4823392 49.3142438 53.4823392 49.3142438 53.4809501"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3135492,53.4830338 C49.3135492,53.4816446 49.3135492,53.4816446 49.3149383,53.4802555 C49.3135492,53.4816446 49.3135492,53.4816446 49.3135492,53.4830338",
    id: "Fill-45",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.306959,53.4930014 C49.2986242,53.509671 49.3458547,53.4291013 49.306959,53.4930014",
    id: "Fill-47",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.3128546,53.4830338 L49.3156329,53.4802555 C49.3142438,53.4816446 49.3142438,53.4830338 49.3128546,53.4830338",
    id: "Fill-49",
    fill: "#C5CFD6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Photo-Background",
    fill: "#DDE3E9",
    x: 0,
    y: 0,
    width: 98.6284875,
    height: 65.2892805,
    rx: 2.77826725
  }), /*#__PURE__*/React.createElement("g", {
    id: "icons8-night_landscape",
    transform: "translate(8.106146, 18.753304)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Mountains",
    fill: "#AFB9C5",
    points: "28.5154405 0 0 46.5359765 57.0308811 46.5359765"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Mountains",
    fill: "#C5CFD6",
    points: "57.9164537 12.4649937 32.7071512 46.5359765 83.1257562 46.5359765"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Sun",
    fill: "#FFFFFF",
    cx: 76.7496329,
    cy: 21.8788546,
    r: 9.37665198
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M207.146203,74.3323524 L244.02004,88.7019312 C252.980924,88.7176994 260.714393,89.6524669 267.220447,91.5062338 C268.868238,92.3581889 271.123803,94.3733225 265.517929,95.4226949 C259.912055,96.4720672 254.062712,97.8279664 253.806822,99.9045142 C253.550933,101.981062 257.475146,103.330899 256.620453,106.269207 C256.050658,108.22808 250.093177,105.295412 238.748009,97.4712053 L204.846509,92.9944131 L207.146203,74.3323524 Z",
    id: "Arm",
    fill: "#B28B67",
    transform: "translate(236.969859, 90.594950) rotate(-38.000000) translate(-236.969859, -90.594950) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Head/Front",
    transform: "translate(122.000000, 35.800301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Head",
    transform: "translate(4.000000, 7.000000)",
    fill: "#B28B67"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1433414,9.13393292 C43.9381521,19.9350547 43.249578,47.3329958 35.7603014,49.2634576 C32.773664,50.0333035 26.4113241,48.1475566 19.935865,44.2446031 L24,73 L0,73 L8.26160177,34.4893378 C3.65406109,29.0807313 0.535660132,22.452516 1.05677633,15.0254539 C2.55833022,-6.37502057 32.3485306,-1.66718886 38.1433414,9.13393292 Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M10.4181384,46.3075201 C7.40590211,32.9064588 -1.17546729,23.7714043 0.135113665,17.781703 C1.0088343,13.7885688 3.33756172,11.3053788 7.12129592,10.3321331 C9.07820742,2.41550085 15.3896485,-0.9517514 26.0556193,0.230376334 C42.0545754,2.00356794 51.8194476,8.64775871 47.6024819,23.2678779 C43.7260987,23.2678779 39.0464758,21.8659867 32.57553,24.2678779 C30.5223249,25.0299883 29.0538125,27.3933595 28.1699927,31.3579915 L25.2457978,31.3579915 C22.4077436,26.6530572 19.6094038,24.9241222 16.8507787,26.1711866 C14.0921535,27.418251 13.4650732,30.4473753 14.9695377,35.2585597 L13.529076,46.3075201 L10.4181384,46.3075201 Z",
    id: "Hair",
    fill: "#191847"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Bottom/Skinny-Jeans-1",
    transform: "translate(0.000000, 198.800301)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Seat-Stuff",
    transform: "translate(55.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#C5CFD6",
    points: "27.6226415 0 104.877193 0 115 124 0 124"
  }), /*#__PURE__*/React.createElement("polygon", {
    fillOpacity: 0.1,
    fill: "#000000",
    points: "27.6226415 0 51.3828011 0 65.6037736 124 0 124"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M247.954028,20.756908 L248.24189,20.5887017 C256.50855,15.9575335 270.00938,22.2466943 270.000005,29.2384154 C269.971611,50.4029106 250.656682,150.1511 249.648224,156.456711 C248.639766,162.762321 237.83665,164.42787 237.20755,156.477375 C236.206544,143.826795 234.3468,100.033121 236.20755,79.7626522 C236.975689,71.3947628 237.802939,63.4254961 238.617343,56.3158982 C228.483775,74.6174738 212.808496,100.823961 191.593128,134.933778 L180.076573,129.672175 C189.120166,99.8760987 196.535776,78.8408618 202.323403,66.5664641 C205.899113,58.9831012 209.394396,51.7927571 212.58547,45.4013011 L213.129489,44.3135245 C218.53905,33.5155316 223.017031,25.1334494 225.436043,21.2120072 C231.587899,11.2392801 242.296386,14.7194928 247.954028,20.756908 Z",
    id: "Skin",
    fill: "#B28B67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.819223,123.340112 L203.936922,21.8299349 C207.625361,4.27739957 238.84365,12.4235349 238.830816,21.8299349 C238.801666,43.1853748 225.973522,116.956762 225.964839,123.319261 L198.819223,123.340112 Z",
    id: "LegLower",
    fill: "#1F28CF",
    transform: "translate(218.825019, 67.419630) rotate(20.000000) translate(-218.825019, -67.419630) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Right-Shoe",
    transform: "translate(200.316987, 140.977241) rotate(30.000000) translate(-200.316987, -140.977241) translate(171.316987, 130.477241)",
    fill: "#E4E4E4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.67736738,6.40396497 C0.55912246,9.38942887 0,11.6233308 0,13.1056708 C0,14.908957 0.300414205,17.5404001 0.901242614,21 C2.99318117,21 21.7937852,21 57.3030548,21 C58.768738,16.1545073 57.9226607,13.5385816 54.7648228,13.1522232 C51.606985,12.7658647 48.9837155,12.4170139 46.8950143,12.1056708 L20.6799926,0.41888346 C20.1755635,0.194006431 19.584344,0.4206282 19.359467,0.925057349 C19.35562,0.933686736 19.3518954,0.94237021 19.3482945,0.951105155 L17.6632131,5.03869504 L17.6632131,5.03869504 C14.7398812,6.40265216 12.3643706,7.08463071 10.5366811,7.08463071 C9.05079105,7.08463071 6.99840749,6.48414931 4.37953046,5.28318651 L4.37949395,5.28326662 C3.37438832,4.82518752 2.18824274,5.26864014 1.73016365,6.27374577 C1.71072872,6.31638941 1.69279862,6.35970296 1.67640655,6.40360623 Z",
    id: "shoe"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Right-Shoe",
    transform: "translate(233.000000, 145.000000)",
    fill: "#E4E4E4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.67736738,6.40396497 C0.55912246,9.38942887 0,11.6233308 0,13.1056708 C0,14.908957 0.300414205,17.5404001 0.901242614,21 C2.99318117,21 21.7937852,21 57.3030548,21 C58.768738,16.1545073 57.9226607,13.5385816 54.7648228,13.1522232 C51.606985,12.7658647 48.9837155,12.4170139 46.8950143,12.1056708 L20.6799926,0.41888346 C20.1755635,0.194006431 19.584344,0.4206282 19.359467,0.925057349 C19.35562,0.933686736 19.3518954,0.94237021 19.3482945,0.951105155 L17.6632131,5.03869504 L17.6632131,5.03869504 C14.7398812,6.40265216 12.3643706,7.08463071 10.5366811,7.08463071 C9.05079105,7.08463071 6.99840749,6.48414931 4.37953046,5.28318651 L4.37949395,5.28326662 C3.37438832,4.82518752 2.18824274,5.26864014 1.73016365,6.27374577 C1.71072872,6.31638941 1.69279862,6.35970296 1.67640655,6.40360623 Z",
    id: "shoe"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M272.770373,36.4330278 C272.770373,63 260.1536,124.970293 260.145616,130.820112 L233,130.840963 C236.973277,75.5454811 238.382172,47.5998928 237.226683,47.0041979 C235.49345,46.1106556 166.175838,53.9250306 145.386358,53.9250306 C115.407825,53.9250306 103.006307,35.0203971 102,0 L161.386358,0 C173.477954,1.29386693 236.548825,14.0152568 259.972097,18.3884129 C270,20.2606358 272.770373,29.1145109 272.770373,36.4330278 Z",
    id: "Leg-and-Butt",
    fill: "#2B44FF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102,207.800301 L179,207.800301 C161.558211,154.605682 152.648283,118.096203 152.270216,98.2718627 C152.250941,97.2611987 150.384379,95.480266 149.55857,95.713495 C143.519523,97.4190735 137.057267,96.7813422 130.1718,93.8003012 C111.917485,123.158708 105.604826,159.304851 102,207.800301 Z",
    id: "Shirt",
    fill: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.922675,84.8003012 L240,105.173782 C208.786296,125.248886 177.179799,140.799918 149.484777,138.590938 C161.512447,190.177207 160.958039,232.406267 134.407472,232.406267 L93.3511268,232.406267 C86.8304314,188.584248 103.968095,127.823916 119.855955,97.1768955 C120.462665,96.0065781 121.75441,93.8003012 124.797001,93.8003012 L136.726763,93.8003012 C136.732077,93.816301 136.73739,93.8323007 136.742703,93.8483004 C158.814341,94.0284431 194.62406,98.0589384 235.922675,84.8003012 Z",
    id: "Coat-Front",
    fill: "#1F28CF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Plant",
    transform: "translate(7.146843, 174.785617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.90250499,24.8212967 C19.8676304,46.5719888 34.9678802,67.6326388 44.0361159,91.4138267 C43.6706887,88.6107487 43.2832146,85.8105742 42.8495169,83.0143843 C40.5485763,68.1917984 37.6888814,53.4773721 34.6838288,38.7809844 C33.1534774,31.2982975 31.5349473,23.8427279 29.8749055,16.3877958 C28.9820835,12.3837492 28.1002084,8.37726297 27.1889894,4.37702928 C26.9682723,3.40747818 26.7786311,1.71518364 26.502304,0 C35.3151894,28.9194548 43.8137824,57.860716 50.0302015,87.4754048 C50.8457129,91.3620167 51.5401821,95.241723 52.1090474,99.1146791 C52.303649,98.2311639 52.4950573,97.347499 52.704562,96.4664051 C55.2198407,85.9039166 58.9928398,75.4254968 63.485256,65.549365 C65.6328973,60.8263617 68.0997662,56.2067897 71.0042812,51.9022895 C72.8154824,49.2191045 77.0868582,46.0295562 78.7391226,43.2815836 C69.7029595,59.8549739 66.4401688,80.5917219 61.2226846,98.609966 C59.9491979,103.006933 58.6678002,107.396762 57.4122566,111.794324 C65.2804436,96.0150099 77.4881073,83.0503861 94.4610866,77.432091 C73.9159495,91.0069659 61.592775,114.779966 53.2886479,139.093781 C53.261285,139.382129 53.2287521,139.670481 53.2006291,139.959285 C55.6442231,135.321643 58.7222973,131.126909 62.8940622,128.188978 C71.8227874,121.899586 81.7276611,123.731793 90.3888459,129.126815 C83.5912737,124.80581 71.3060791,128.7405 65.5865577,133.13227 C61.4920003,136.276095 57.9927374,140.493775 54.954002,144.608533 C54.2258848,145.59487 53.2325169,146.7457 52.1830823,147.973629 C50.7117319,157.524476 48.3140062,167.009867 44.9193449,176.419971 C45.4795528,173.718981 45.074511,169.399204 45.2298644,167.385961 C45.2467743,167.167993 45.2604909,166.949875 45.277249,166.732514 C44.7612394,168.792827 44.2627036,170.829721 43.7827007,172.833771 C44.736878,169.009585 45.2554675,165.017454 45.6602946,160.984061 C45.7645593,159.250672 45.866239,157.517284 45.973697,155.784044 C45.9396395,152.494509 45.804152,149.191974 45.5749936,145.884186 C44.7624391,142.669376 43.8526684,139.637025 43.1023853,137.115254 C40.3949682,128.015907 36.4259829,119.298501 31.5408663,111.166004 C27.0837312,103.744676 21.7485425,97.0223756 15.5894017,90.9428269 C12.2690681,87.6664205 8.79417758,84.5459157 5.36822578,81.3820584 C4.12938206,80.238289 1.91507317,77.4260389 0,75.9600718 C13.9472402,83.6492974 28.3028012,91.9679348 38.4773404,104.357001 C37.2844924,99.7763589 35.9888888,95.2605383 34.6183706,90.8352061 C27.6653931,68.3832021 18.8861994,45.1138691 6.90250499,24.8212967 Z",
    id: "Fill-19",
    fill: "#DDE3E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8370044,147.942731 C20.8370044,172.876644 22.8115271,193.089574 49.3142438,193.089574 C75.8169604,193.089574 77.7914831,172.876644 77.7914831,147.942731",
    id: "Base",
    fill: "#C5CFD6"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmmortamenti);
export default __webpack_public_path__ + "static/media/ammortamenti.c1c296fa3ae8bfc71ac6eb3facef5eb5.svg";
export { ForwardRef as ReactComponent };